import {
	SET_OFFICE_OPEN_INFO,
	SET_ALERT_SETTING_POPUP,
	SET_ALERT_PREFERENCES,
	RESET_ALERT_PREFERENCES,
	RESET_ORGANIZATION_STATE,
	SET_APP_USER_INTERACTION_RECEIVED,
	SET_ORGANIZATION_PROFILE,
	SET_ORGANIZATION_ID,
	SET_SHOW_ORGANIZATION_RESTRICTED_ACCESS_NOTE,
	SET_ORGANIZATION_PANEL_EXPAND_FROM_ATTENTION,
} from '@/store/mutation-types'

const getDefaultAlertPreferences = () => ({
	id: null,
	audio_alert_enabled: false,
	visual_alert_enabled: false,
	inactivity_threshold_minutes: 5,
	alert_sound: null,
	alert_color: 'orange',
})

export default {
	[SET_OFFICE_OPEN_INFO](state, officeOpenInfo) {
		state.officeOpenInfo = officeOpenInfo
	},

	[SET_ALERT_SETTING_POPUP](state, alertSettingsPopup) {
		state.alertSettingsPopup = alertSettingsPopup
	},

	[SET_ALERT_PREFERENCES](state, alertPreferences) {
		state.alertPreferences = {
			...state.alertPreferences,
			...(alertPreferences?.omd || {}),
			...(alertPreferences?.id && { id: alertPreferences.id }),
		}
	},

	[RESET_ALERT_PREFERENCES](state) {
		state.alertPreferences = getDefaultAlertPreferences()
	},

	[RESET_ORGANIZATION_STATE](state) {
		state.organizationProfile = null
		state.organizationId = null
		state.showOrganizationRestrictedAccessNote = false
		state.organizationPanelExpandFromAttention = false
	},

	[SET_APP_USER_INTERACTION_RECEIVED](state, value = true) {
		state.appUserInteractionReceived = Boolean(value)
	},

	[SET_ORGANIZATION_PROFILE](state, organizationProfile) {
		state.organizationProfile = organizationProfile
			? { ...organizationProfile }
			: null
	},

	[SET_ORGANIZATION_ID](state, organizationId) {
		state.organizationId = organizationId
	},

	[SET_SHOW_ORGANIZATION_RESTRICTED_ACCESS_NOTE](state, value = false) {
		state.showOrganizationRestrictedAccessNote = Boolean(value)
	},

	[SET_ORGANIZATION_PANEL_EXPAND_FROM_ATTENTION](state, value = false) {
		state.organizationPanelExpandFromAttention = Boolean(value)
	},
}
